module.exports = __webpack_public_path__ + "static/media/brand-white.987826c8.svg";